import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomWindow, WINDOW } from '../../lib/services/window.service';
import { isAddOrUpdateAddressResponse } from '../guards';

@Injectable()
export class AddressInterceptor implements HttpInterceptor {
	constructor(@Inject(WINDOW) private window: CustomWindow) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			tap((event: HttpEvent<any>) => {
				if (request.method !== 'GET' && event instanceof HttpResponse && isAddOrUpdateAddressResponse(event.body)) {
					if (
						this.window.COUNTDOWN_NS &&
						typeof this.window.COUNTDOWN_NS.SetDeliveryAddressInShopInfoPanel === 'function'
					) {
						const shopperAddresses = event.body?.shopperAddresses?.filter(Boolean) || [];
						const primaryAddress = shopperAddresses.find((a) => a.isPrimary);
						const fullAddress = `${primaryAddress?.address?.street1},${primaryAddress?.address?.street2 || ''}`.replace(
							/,$/,
							''
						);
						if (primaryAddress && primaryAddress.address) {
							this.window.COUNTDOWN_NS.SetDeliveryAddressInShopInfoPanel(fullAddress);
						}
					}
				}
			})
		);
	}
}
